import React from 'react';
import { Outlet } from 'react-router-dom';
import { useTranslate } from '../lib/i18n';
import { useConfig } from '../hooks';

const TrainingToolLayout = () => {
  const t = useTranslate();
  const { data: chatbotConfig, isLoading: isConfigLoading } = useConfig();
  if (isConfigLoading || !chatbotConfig) {
    return <div>Loading...</div>;
  }
  return (
    <>
      <title>{`${t('operatorChatbot.title')} | ${chatbotConfig.title}`}</title>
      <Outlet />
    </>
  );
};

export default TrainingToolLayout;
